export default {
  title: "Системные уведомления",
  eventNameInputPlaceholder: "Название выставки",
  typeNotificationTitle: "Тип",
  notifications: "Уведомления",
  allNotifications: "Все уведомления",
  readAllNotification: "Отметить всё как прочитанное",
  showMore: "Показать ещё",
  showAll: "Показать всё",
  emailNotification: "E-mail уведомления",
  notNotifications: "Нет уведомлений",
  searchCompany: "Поиск по компании",
  noServicesFound: "Услуг не найдено",
  typeNotification: {
    exhibition_personal_pass_registration_deadline:
      "Оформление удостоверений участников выставки {event} заканчивается {date}.",
    exhibition_personal_pass_print_closes:
      "Печать удостоверений участников выставки {event} заканчивается {date}.",
    exhibition_mounting_pass_print_closes:
      "Печать пропусков на монтаж/демонтаж выставки {event} заканчивается {date}.",
    exhibition_mounting_pass_registration_deadline:
      "Оформление пропусков на монтаж/демонтаж выставки {event} заканчивается {date}.",
    exhibition_catalogue_placement_deadline:
      "Прием заявок на размещение в каталоге выставки {event} заканчивается {date}.",
    exhibition_car_pass_ready:
      "Вы можете распечатать/скачать разовый пропуск на въезд на выставку {event}.",
    exhibition_personal_pass_registration_deadline_company:
      "Для компании «{company}» оформление удостоверений участников выставки {event} заканчивается {date}.",
    exhibition_personal_pass_print_closes_company:
      "Для компании «{company}» печать удостоверений участников выставки {event} заканчивается {date}.",
    exhibition_mounting_pass_print_closes_company:
      "Для компании «{company}» печать пропусков на монтаж/демонтаж выставки {event} заканчивается {date}.",
    exhibition_mounting_pass_registration_deadline_company:
      "Для компании «{company}» оформление пропусков на монтаж/демонтаж выставки {event} заканчивается {date}.",
    exhibition_catalogue_placement_deadline_company:
      "Для компании «{company}» прием заявок на размещение в каталоге выставки {event} заканчивается {date}.",
    exhibition_car_pass_ready_company:
      "Для компании «{company}» вы можете распечатать/скачать разовый пропуск на въезд на выставку {event}.",
    exhibition_invoice_ready_company:
      "Счета на оплату по выставке {event} доступны в разделе «Документы».",
    exhibition_act_ready_company:
      "Акты оказанных услуг по выставке {event} доступны в разделе «Документы».",
    paid_pass_available_at_service_bureau_company:
      "Оплаченный вашей компанией пропуск (автомобильный/промоутера) по выставке {event} необходимо получить в Сервис Бюро.",
    payment_has_not_been_made_in_full_company:
      "Оплата произведена не полностью. Счета на оплату по выставке {event} доступны в разделе «Документы»."
  },
  emailNotifications: {
    certificate_email_notify: "Удостоверения участников",
    installation_email_notify: "Пропуска на монтаж/демонтаж",
    car_pass_email_notify: "Платные пропуска",
    catalog_order_email_notify: "Заявки в каталог",
    document_email_notify: "Закрывающие документы",
    additional_services: "Заказ дополнительных услуг"
  }
};
